<div class="media-detail">
  <div class="media-detail__header">
    <app-details-header
      [title]="title()"
      [badgeText]="badgeText()"
      [badgeColor]="badgeColor()"
      [measureDate]="measureDate()" />
  </div>

  <div class="media-detail__body">
    @if (loading()) {
      <div class="media-detail__loading">
        <div class="skeleton skeleton--video"></div>
        <div class="skeleton skeleton--text"></div>
        <div class="skeleton skeleton--text skeleton--short"></div>
      </div>
    } @else if (error()) {
      <div class="media-detail__error">
        <mat-icon class="media-detail__error-icon">error_outline</mat-icon>
        <p i18n="@@home.mediaDetail.error.loadFailed">メディアの読み込みに失敗しました</p>
        <button mat-stroked-button (click)="goBack()" i18n="@@home.mediaDetail.button.backToList">一覧に戻る</button>
      </div>
    } @else {
      <div class="media-detail__content-grid">
        <!-- Media Content -->
        <div class="media-content">
          @if (isStatusDeleted()) {
            <div class="encoding-placeholder">
              <div class="encoding-status">
                <mat-icon class="encoding-icon encoding-icon--static">delete_outline</mat-icon>
                <span i18n="@@home.mediaDetail.label.deleted">削除されました</span>
              </div>
            </div>
          } @else if (isStatusError()) {
            <div class="encoding-placeholder">
              <div class="encoding-status">
                <mat-icon class="encoding-icon encoding-icon--static error-icon">error_outline</mat-icon>
                <span i18n="@@home.mediaDetail.label.statusError">エラーが発生しました</span>
              </div>
            </div>
          } @else if (media()?.data?.mediaType === 'Video') {
            @if (media()?.data?.mediaStatus === 'Encoded') {
              <app-media-video-player
                [playerInstance]="playerInstance"
                [thumbnailUrl]="thumbnailUrl()">
                <div class="video-container" #mkplayerdiv></div>
              </app-media-video-player>
            } @else {
              <div class="encoding-placeholder">
                <div class="encoding-shimmer"></div>
                <div class="encoding-status">
                  <mat-icon class="encoding-icon">hourglass_top</mat-icon>
                  <span i18n="@@home.mediaDetail.label.encoding">エンコード中...</span>
                </div>
              </div>
            }
          } @else {
            <img [src]="imageUrl()" alt="" class="media-image" />
          }
        </div>

        <!-- Meta Info -->
        <div class="media-info">
          <div class="media-info__tags">
            @if (media()?.data?.mediaType === 'Image') {
              <span class="tag tag--outline" i18n="@@home.mediaDetail.label.image">静止画</span>
            }
            @if (media()?.data?.mediaType === 'Video') {
              <span class="tag tag--outline" i18n="@@home.mediaDetail.label.video">動画</span>
            }
            <span class="tag tag--method" [attr.data-method]="media()?.data?.method">
              {{ media()?.data?.method }}
            </span>
          </div>

          <div class="media-info__date">
            <mat-icon class="media-info__icon">calendar_today</mat-icon>
            <span i18n="@@home.mediaDetail.label.createdAt">作成日: {{ media()?.data?.createdAt | date:'yyyy/MM/dd HH:mm' }}</span>
          </div>

          @if (media()?.data?.comment) {
            <div class="media-info__comment">
              <h4>
                <mat-icon class="media-info__icon">comment</mat-icon>
                <ng-container i18n="@@home.mediaDetail.label.comment">コメント</ng-container>
              </h4>
              <p>{{ media()?.data?.comment }}</p>
            </div>
          }

          @if (media()?.data?.tags?.length) {
            <div class="media-info__tags-section">
              <h4>
                <mat-icon class="media-info__icon">label</mat-icon>
                <ng-container i18n="@@home.mediaDetail.label.tags">タグ</ng-container>
              </h4>
              <div class="media-info__tag-list">
                @for (tag of media()?.data?.tags; track tag) {
                  <span class="tag tag--outline">{{ tag }}</span>
                }
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Actions -->
      <div class="media-detail__actions">
        @if (linkedRecord()) {
          <button mat-flat-button color="primary" (click)="navigateToRecord()">
            <mat-icon>open_in_new</mat-icon>
            <span i18n="@@home.mediaDetail.button.viewRecord">VSレコード詳細を見る</span>
          </button>
        }
        <button mat-stroked-button (click)="downloadMedia()">
          <mat-icon>download</mat-icon>
          <span i18n="@@home.mediaDetail.button.download">ダウンロード</span>
        </button>
        <button mat-stroked-button color="warn" (click)="confirmDelete()">
          <mat-icon>delete</mat-icon>
          <span i18n="@@home.mediaDetail.button.delete">削除</span>
        </button>
      </div>
    }
  </div>
</div>
